export default __webpack_public_path__ + "static/media/tweet.416851b8.svg";